import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const VastuSidebar = ({ collapsed, onLinkClick }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuGroups = [
    {
      group: 'Overview',
      items: [
        { 
          id: 'dashboard', 
          label: 'Dashboard', 
          icon: 'bi-house-door', 
          path: '/pannel/dashboard'
        },
        { 
          id: 'dashboard', 
          label: 'Editor', 
          icon: 'bi-file-earmark-text', 
          path: '/pannel/editor'
        },
      ],
    },
  ];

  const isActive = (item) => {
    const currentPath = location.pathname;
    return currentPath === item.path || currentPath.startsWith(item.path + '/');
  };

  const handleItemClick = (item) => {
    navigate(item.path);
    if (onLinkClick) {
      onLinkClick();
    }
  };

  return (
    <>
      <div
        className={`vastu-sidebar d-flex flex-column position-fixed position-lg-sticky top-0 h-100 ${
          collapsed ? 'sidebar-collapsed' : 'sidebar-expanded'
        }`}
      >
        {/* Sidebar Header */}
        {/* <div className="sidebar-header px-4 py-4">
          <div className="d-flex align-items-center justify-content-center">
            {!collapsed && (
              <div className="brand-text text-center">
                <h5 className="mb-0 fw-bold">Vastu Analyzer</h5>
              </div>
            )}
            {collapsed && (
              <div className="brand-icon">
                <i className="bi bi-house-heart"></i>
              </div>
            )}
          </div>
        </div> */}

        {/* Navigation Menu */}
        {/* <nav className="sidebar-nav flex-fill px-3 h-100">
          {menuGroups.map((group) => (
            <div key={group.group} className="menu-group">
              <ul className="nav flex-column">
                {group.items.map((item) => (
                  <li key={item.id} className="nav-item">
                    <button
                      className={`nav-link-custom d-flex align-items-center w-100 text-start border-0 ${
                        isActive(item) ? 'active' : ''
                      }`}
                      onClick={() => handleItemClick(item)}
                      title={collapsed ? item.label : ''}
                    >
                      <i className={`bi ${item.icon} nav-icon`}></i>
                      {!collapsed && (
                        <div className="nav-content">
                          <span className="nav-text">{item.label}</span>
                        </div>
                      )}
                      {isActive(item) && <div className="active-indicator"></div>}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav> */}
      </div>

      <style jsx>{`
        .vastu-sidebar {
          background: var(--bg-app);
          color: var(--text-primary);
          width: 260px;
          z-index: 1045;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          overflow: hidden;
          box-shadow: none;
          border-right: 1px solid var(--border);
          height: 100vh;
          display: flex;
          flex-direction: column;
        }

        .sidebar-collapsed {
          width: 0 !important;
          opacity: 0;
          transform: translateX(-100%);
        }

        .sidebar-expanded {
          width: 260px;
          opacity: 1;
          transform: translateX(0);
        }

        .sidebar-header {
          border-bottom: 1px solid var(--border);
          background: transparent;
          flex-shrink: 0;
        }

        .brand-text h5 {
          color: var(--text-primary);
          font-size: 1.15rem;
          font-weight: 700;
        }

        .brand-icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 40px;
          height: 40px;
          background: var(--primary);
          border-radius: var(--radius-md);
          color: #ffffff;
          font-size: 20px;
        }

        .sidebar-nav {
          flex: 1;
          overflow-y: auto;
          padding-top: 1.25rem;
          padding-bottom: 1rem;
        }

        .sidebar-nav::-webkit-scrollbar { width: 6px; }
        .sidebar-nav::-webkit-scrollbar-track { background: transparent; }
        .sidebar-nav::-webkit-scrollbar-thumb {
          background: var(--border-strong);
          border-radius: 3px;
        }
        .sidebar-nav::-webkit-scrollbar-thumb:hover { background: var(--text-muted); }

        .menu-group { margin-bottom: 1.25rem; }
        .nav-item { margin-bottom: 4px; }

        .nav-link-custom {
          padding: 11px 14px;
          border-radius: var(--radius-md);
          background: transparent;
          color: var(--text-secondary);
          text-decoration: none;
          transition: background 0.18s ease, color 0.18s ease;
          font-weight: 500;
          font-size: 14px;
          position: relative;
          border: 0;
          cursor: pointer;
        }

        .nav-link-custom:hover:not(.active) {
          background: var(--bg-hover);
          color: var(--text-primary);
        }

        .nav-link-custom.active {
          background: var(--primary);
          color: #ffffff;
          font-weight: 600;
          box-shadow: var(--shadow-primary);
        }

        .active-indicator {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          width: 6px;
          height: 6px;
          background: #ffffff;
          border-radius: 50%;
        }

        .nav-icon {
          width: 20px;
          height: 20px;
          font-size: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 12px;
          color: inherit;
          flex-shrink: 0;
        }

        .nav-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          min-width: 0;
        }

        .nav-text {
          font-weight: inherit;
          letter-spacing: 0.02em;
          line-height: 1.2;
        }

        .sidebar-footer {
          border-top: 1px solid var(--border);
          background: transparent;
          flex-shrink: 0;
        }

        .footer-content {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .copyright {
          color: var(--text-muted);
          font-size: 0.75rem;
          text-align: center;
        }

        .footer-collapsed { padding: 8px 0; }

        .footer-icon {
          color: var(--primary);
          font-size: 24px;
        }

        @media (max-width: 991.98px) {
          .sidebar-expanded {
            position: fixed;
            left: 0;
            top: 0;
            height: 100vh;
            z-index: 1045;
          }
        }
      `}</style>
    </>
  );
};

export default VastuSidebar;